import React, { useCallback, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Menu, MenuItem } from '@mui/material';
import { actions } from './Clients.redux';
import { useNavigate } from '@tanstack/react-router';
import DeletePopover from 'components/DeletePopover';

const ClientCell = (params) => {
    const { row, field } = params;
    const id = row.client_id;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const actionAnchor = useRef(null);
    const [actionsOpen, setActionsOpen] = useState(false);

    const beforeDeleteClient = useCallback(() => {
        dispatch(actions.setState({ loading: true }));
    }, [dispatch]);

    const afterDeleteClient = useCallback(() => {
        setActionsOpen(false);
        dispatch(actions.search());
    }, [dispatch]);

    const handleNavigate = useCallback(() => {
        navigate({ to: `/clients/view/${id}` });
    }, [navigate, id]);

    if (field === 'actions') {
        return (
            <>
                <Button
                    variant="outlined"
                    size="small"
                    onClick={(event) => {
                        event.stopPropagation();
                        setActionsOpen(true);
                    }}
                    ref={actionAnchor}
                >
                    ...
                </Button>
                <Menu open={actionsOpen} onClose={() => setActionsOpen(false)} anchorEl={actionAnchor.current}>
                    <MenuItem onClick={(event) => event.stopPropagation()}>
                        <DeletePopover
                            objectType="CLIENT"
                            objectID={id}
                            afterDelete={afterDeleteClient}
                            beforeDelete={beforeDeleteClient}
                        >
                            <Button variant="text" size="large" color="error">
                                Delete Client
                            </Button>
                        </DeletePopover>
                    </MenuItem>
                </Menu>
            </>
        );
    }

    return <span onClick={handleNavigate}>{params.value ?? ''}</span>;
};

export default ClientCell;
